import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './pci-dss-compliance.css'

const PCIDSSCompliance = (props) => {
  return (
    <div className="pcidss-compliance-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="PCI-DSS-Compliance - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/pci-dss-compliance"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section pci-dss-compliance-hero-section">
        <video
          src="https://videos.pexels.com/video-files/6963746/6963746-hd_1280_720_25fps.mp4"
          loop="true"
          muted="true"
          autoPlay="true"
          playsInline="true"
          className="hero-video"
        ></video>
        <div className="hero-overlay"></div>
        <div className="hero-content pci-dss-compliance-hero-content">
          <div className="pci-dss-compliance-hero-content-inner">
            <div className="hero-icon">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                viewbox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <h1 className="hero-title pci-dss-compliance-hero-title">
              PCI-DSS Compliance &amp; Readiness Assessment
            </h1>
            <p className="pci-dss-compliance-hero-subtitle hero-subtitle">
              Comprehensive validation, controls testing, and evidence
              collection to achieve and maintain Payment Card Industry Data
              Security Standard compliance
            </p>
            <div className="hero-actions">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Start Assessment</span>
                </div>
              </a>
              <a href="#methodology">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>Our Approach</span>
                  
                </div>
              </a>
            </div>
            <div className="hero-stats">
              <div className="hero-stat">
                <span className="hero-stat-number">12+</span>
                <span className="hero-stat-label">Requirements</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-number">300+</span>
                <span className="hero-stat-label">Controls</span>
              </div>
              <div className="hero-stat">
                <span className="hero-stat-number">100%</span>
                <span className="hero-stat-label">Evidence Tracked</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="challenges-section">
        <div className="challenges-container">
          <div className="pci-dss-compliance-challenges-header">
            <h2 className="section-title">Common PCI-DSS Challenges</h2>
            <p className="section-subtitle">
              Addressing the most critical roadblocks to achieving and
              maintaining compliance
            </p>
          </div>
          <div className="challenges-steps">
            <div className="challenge-step">
              <div className="challenge-step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <div className="challenge-step-content">
                <h3 className="challenge-step-title">Gap Analysis</h3>
                <p className="challenge-step-description">
                  Identifying control deficiencies between current state and
                  PCI-DSS requirements across all 12 domains
                </p>
              </div>
              <div className="challenge-step-number">
                <span>01</span>
              </div>
            </div>
            <div className="challenge-step-connector"></div>
            <div className="challenge-step">
              <div className="challenge-step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <path d="m9 14l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="challenge-step-content">
                <h3 className="challenge-step-title">Evidence Collection</h3>
                <p className="challenge-step-description">
                  Systematic documentation and validation of control
                  implementations with audit-ready evidence packages
                </p>
              </div>
              <div className="challenge-step-number">
                <span>02</span>
              </div>
            </div>
            <div className="challenge-step-connector"></div>
            <div className="challenge-step">
              <div className="challenge-step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <path d="M12 11h4m-4 5h4m-6-5h.01M8 16h.01"></path>
                  </g>
                </svg>
              </div>
              <div className="challenge-step-content">
                <h3 className="challenge-step-title">Control Mapping</h3>
                <p className="challenge-step-description">
                  Comprehensive alignment of organizational controls to PCI-DSS
                  requirements and sub-requirements
                </p>
              </div>
              <div className="challenge-step-number">
                <span>03</span>
              </div>
            </div>
            <div className="challenge-step-connector"></div>
            <div className="challenge-step">
              <div className="challenge-step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="challenge-step-content">
                <h3 className="challenge-step-title">Sustaining Compliance</h3>
                <p className="challenge-step-description">
                  Continuous monitoring, periodic assessments, and control
                  effectiveness validation throughout the year
                </p>
              </div>
              <div className="challenge-step-number">
                <span>04</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="methodology" className="methodology-section">
        <div className="methodology-container">
          <div className="methodology-header">
            <h2 className="section-title">Our PCI-DSS Readiness Methodology</h2>
            <p className="section-subtitle">
              A structured, phase-based approach to achieving comprehensive
              compliance
            </p>
          </div>
          <div className="methodology-steps">
            <div className="methodology-step">
              <div className="methodology-step-visual">
                <div className="methodology-step-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m21 21l-4.34-4.34"></path>
                      <circle r="8" cx="11" cy="11"></circle>
                    </g>
                  </svg>
                </div>
                <div className="methodology-step-number">
                  <span>Phase 1</span>
                </div>
              </div>
              <h3 className="methodology-step-title">
                Scoping &amp; Discovery
              </h3>
              <p className="methodology-step-description">
                Detailed analysis of cardholder data environment, payment
                processing flows, network segmentation, and system inventory to
                establish accurate compliance boundaries
              </p>
              <ul className="methodology-step-list">
                <li>
                  <span>CDE boundary identification</span>
                </li>
                <li>
                  <span>Data flow mapping</span>
                </li>
                <li>
                  <span>Asset inventory compilation</span>
                </li>
                <li>
                  <span>Merchant level classification</span>
                </li>
              </ul>
            </div>
            <div className="methodology-step-connector"></div>
            <div className="methodology-step">
              <div className="methodology-step-visual">
                <div className="methodology-step-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <div className="methodology-step-number">
                  <span>Phase 2</span>
                </div>
              </div>
              <h3 className="methodology-step-title">Controls Validation</h3>
              <p className="methodology-step-description">
                Rigorous testing and validation of technical and administrative
                controls across all 12 PCI-DSS requirements to assess
                effectiveness and identify gaps
              </p>
              <ul className="methodology-step-list">
                <li>
                  <span>Configuration reviews</span>
                </li>
                <li>
                  <span>Access control testing</span>
                </li>
                <li>
                  <span>Vulnerability assessments</span>
                </li>
                <li>
                  <span>Policy effectiveness evaluation</span>
                </li>
              </ul>
            </div>
            <div className="methodology-step-connector"></div>
            <div className="methodology-step">
              <div className="methodology-step-visual">
                <div className="methodology-step-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                      <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                    </g>
                  </svg>
                </div>
                <div className="methodology-step-number">
                  <span>Phase 3</span>
                </div>
              </div>
              <h3 className="methodology-step-title">Evidence Collection</h3>
              <p className="methodology-step-description">
                Comprehensive documentation of control implementations through
                screenshots, configuration exports, policy documents, and
                procedural walkthroughs
              </p>
              <ul className="methodology-step-list">
                <li>
                  <span>Technical evidence artifacts</span>
                </li>
                <li>
                  <span>Policy documentation packages</span>
                </li>
                <li>
                  <span>Interview transcripts</span>
                </li>
                <li>
                  <span>Testing result summaries</span>
                </li>
              </ul>
            </div>
            <div className="methodology-step-connector"></div>
            <div className="methodology-step">
              <div className="methodology-step-visual">
                <div className="methodology-step-icon">
                  <svg
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                    height="32"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                      <circle r="3" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
                <div className="methodology-step-number">
                  <span>Phase 4</span>
                </div>
              </div>
              <h3 className="methodology-step-title">Remediation Roadmap</h3>
              <p className="methodology-step-description">
                Prioritized action plan with timelines, resource requirements,
                and implementation guidance to address identified gaps and
                achieve full compliance
              </p>
              <ul className="methodology-step-list">
                <li>
                  <span>Risk-based prioritization</span>
                </li>
                <li>
                  <span>Remediation work packages</span>
                </li>
                <li>
                  <span>Timeline development</span>
                </li>
                <li>
                  <span>Attestation preparation</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="pci-dss-compliance-deliverables-section">
        <div className="pci-dss-compliance-deliverables-header deliverables-header">
          <h2 className="section-title">
            Compliance Deliverables &amp; Artifacts
          </h2>
          <p className="section-subtitle">
            Comprehensive documentation packages supporting your PCI-DSS
            attestation
          </p>
        </div>
        <div className="pci-dss-compliance-deliverables-grid">
          <article className="pci-dss-compliance-deliverable-card">
            <div className="deliverable-card-image">
              <img
                alt="Gap analysis reports showing compliance status"
                src="https://images.pexels.com/photos/5380664/pexels-photo-5380664.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              />
            </div>
            <div className="deliverable-card-content">
              <div className="deliverable-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverable-card-title">Gap Analysis Report</h3>
              <p className="deliverable-card-description">
                Detailed assessment of compliance posture with identified
                deficiencies across all requirements
              </p>
            </div>
          </article>
          <article className="pci-dss-compliance-deliverable-card">
            <div className="deliverable-card-image">
              <img
                alt="Control mapping matrices documentation"
                src="https://images.pexels.com/photos/207580/pexels-photo-207580.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              />
            </div>
            <div className="deliverable-card-content">
              <div className="deliverable-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <path d="M12 11h4m-4 5h4m-6-5h.01M8 16h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverable-card-title">Control Mapping Matrix</h3>
              <p className="deliverable-card-description">
                Comprehensive crosswalk linking organizational controls to
                specific PCI-DSS requirements
              </p>
            </div>
          </article>
          <article className="pci-dss-compliance-deliverable-card">
            <div className="deliverable-card-image">
              <img
                alt="Evidence collection packages and documentation"
                src="https://images.pexels.com/photos/5380589/pexels-photo-5380589.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              />
            </div>
            <div className="deliverable-card-content">
              <div className="deliverable-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverable-card-title">Evidence Packages</h3>
              <p className="deliverable-card-description">
                Organized collection of technical artifacts, screenshots, and
                configuration files for each control
              </p>
            </div>
          </article>
          <article className="pci-dss-compliance-deliverable-card">
            <div className="deliverable-card-image">
              <img
                alt="Vulnerability assessment findings and reports"
                src="https://images.pexels.com/photos/6963098/pexels-photo-6963098.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              />
            </div>
            <div className="deliverable-card-content">
              <div className="deliverable-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="deliverable-card-title">
                Vulnerability Scan Reports
              </h3>
              <p className="deliverable-card-description">
                ASV-certified external scan results and internal vulnerability
                assessment findings
              </p>
            </div>
          </article>
          <article className="pci-dss-compliance-deliverable-card">
            <div className="deliverable-card-image">
              <img
                alt="Remediation roadmap and action plan"
                src="https://images.pexels.com/photos/5475763/pexels-photo-5475763.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              />
            </div>
            <div className="deliverable-card-content">
              <div className="deliverable-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="deliverable-card-title">Remediation Roadmap</h3>
              <p className="deliverable-card-description">
                Prioritized action plan with timelines and resource requirements
                for gap closure
              </p>
            </div>
          </article>
          <article className="pci-dss-compliance-deliverable-card">
            <div className="deliverable-card-image">
              <img
                alt="Attestation documentation and compliance certification"
                src="https://images.pexels.com/photos/8720589/pexels-photo-8720589.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              />
            </div>
            <div className="deliverable-card-content">
              <div className="deliverable-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="deliverable-card-title">
                Attestation of Compliance
              </h3>
              <p className="deliverable-card-description">
                Supporting documentation for SAQ or ROC completion and
                compliance validation
              </p>
            </div>
          </article>
        </div>
      </section>
      <section className="requirements-section">
        <div className="requirements-container">
          <div className="requirements-header">
            <h2 className="section-title">PCI-DSS Requirements Mapping</h2>
            <p className="section-subtitle">
              Comprehensive crosswalk of requirements, controls, and evidence
              artifacts with ISO/SOC alignment
            </p>
          </div>
          <div className="requirements-table-wrapper">
            <table className="requirements-table">
              <thead>
                <tr>
                  <th className="requirements-table-header">
                    <span>PCI-DSS Requirement</span>
                  </th>
                  <th className="requirements-table-header">
                    <span>Control Domain</span>
                  </th>
                  <th className="requirements-table-header">
                    <span>Evidence Type</span>
                  </th>
                  <th className="requirements-table-header">
                    <span>ISO 27001 Mapping</span>
                  </th>
                  <th className="requirements-table-header">
                    <span>SOC 2 Mapping</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">1</span>
                    <span>Install and maintain network security controls</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Network Security</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Firewall configs, Network diagrams</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.13.1, A.13.2</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC6.6, CC6.7</span>
                  </td>
                </tr>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">2</span>
                    <span>
                      Apply secure configurations to all system components
                    </span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Configuration Management</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Hardening baselines, Config audits</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.12.6, A.14.2</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC7.1, CC7.2</span>
                  </td>
                </tr>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">3</span>
                    <span>Protect stored account data</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Data Protection</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Encryption evidence, Data retention policies</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.8.2, A.10.1</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC6.1, CC6.7</span>
                  </td>
                </tr>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">4</span>
                    <span>
                      Protect cardholder data with strong cryptography
                    </span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Cryptography</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>TLS configs, Key management docs</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.10.1, A.14.1</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC6.1, CC6.7</span>
                  </td>
                </tr>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">5</span>
                    <span>Protect all systems against malware</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Malware Protection</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>AV logs, Malware scan reports</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.12.2, A.12.6</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC7.2, CC7.3</span>
                  </td>
                </tr>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">6</span>
                    <span>Develop and maintain secure systems</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Secure Development</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Patch logs, Change management records</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.14.2, A.12.6</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC7.1, CC8.1</span>
                  </td>
                </tr>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">7</span>
                    <span>Restrict access to system components</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Access Control</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Access lists, Role definitions</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.9.1, A.9.2</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC6.1, CC6.2</span>
                  </td>
                </tr>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">8</span>
                    <span>Identify users and authenticate access</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Identity Management</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>MFA evidence, Password policies</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.9.2, A.9.4</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC6.1, CC6.2</span>
                  </td>
                </tr>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">9</span>
                    <span>Restrict physical access to cardholder data</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Physical Security</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Access logs, Badge systems</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.11.1, A.11.2</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC6.4</span>
                  </td>
                </tr>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">10</span>
                    <span>Log and monitor all access to system components</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Logging &amp; Monitoring</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>SIEM configs, Audit logs</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.12.4, A.16.1</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC7.2, CC7.3</span>
                  </td>
                </tr>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">11</span>
                    <span>Test security of systems regularly</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Security Testing</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Scan reports, Penetration tests</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.12.6, A.18.2</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC7.1, CC7.2</span>
                  </td>
                </tr>
                <tr className="requirements-table-row">
                  <td className="requirements-table-cell">
                    <span className="requirements-table-number">12</span>
                    <span>
                      Support information security with organizational policies
                    </span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Governance</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>Policies, Training records</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>A.5.1, A.7.2</span>
                  </td>
                  <td className="requirements-table-cell">
                    <span>CC1.2, CC2.2</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="pcidss-compliance-thq-timeline-section-elm timeline-section">
        <div className="timeline-header">
          <h2 className="section-title">
            Assessment &amp; Validation Timeline
          </h2>
          <p className="section-subtitle">
            Structured phases for achieving PCI-DSS readiness and attestation
          </p>
        </div>
        <div className="timeline-scroll-container">
          <div className="timeline-track">
            <div className="timeline-item">
              <div className="timeline-item-marker"></div>
              <div className="timeline-item-content">
                <div className="timeline-item-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m21 21l-4.34-4.34"></path>
                      <circle r="8" cx="11" cy="11"></circle>
                    </g>
                  </svg>
                </div>
                <span className="timeline-item-phase">Week 1-2</span>
                <h3 className="timeline-item-title">Initial Discovery</h3>
                <p className="timeline-item-description">
                  Scoping workshop, CDE boundary definition, asset inventory,
                  and data flow mapping
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-item-marker"></div>
              <div className="timeline-item-content">
                <div className="timeline-item-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="8" cx="11" cy="11"></circle>
                      <path d="m21 21l-4.3-4.3M11 7v4m0 4h.01"></path>
                    </g>
                  </svg>
                </div>
                <span className="timeline-item-phase">Week 3-4</span>
                <h3 className="timeline-item-title">Gap Assessment</h3>
                <p className="timeline-item-description">
                  Detailed review of current controls against all PCI-DSS
                  requirements, documentation review
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-item-marker"></div>
              <div className="timeline-item-content">
                <div className="timeline-item-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <span className="timeline-item-phase">Week 5-7</span>
                <h3 className="timeline-item-title">Controls Testing</h3>
                <p className="timeline-item-description">
                  Vulnerability scans, configuration reviews, access testing,
                  security control validation
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-item-marker"></div>
              <div className="timeline-item-content">
                <div className="timeline-item-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                      <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                    </g>
                  </svg>
                </div>
                <span className="timeline-item-phase">Week 8-9</span>
                <h3 className="timeline-item-title">Evidence Assembly</h3>
                <p className="timeline-item-description">
                  Collection and organization of all supporting evidence,
                  documentation packages, artifacts
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-item-marker"></div>
              <div className="timeline-item-content">
                <div className="timeline-item-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                      <circle r="3" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
                <span className="timeline-item-phase">Week 10-12</span>
                <h3 className="timeline-item-title">Remediation Support</h3>
                <p className="timeline-item-description">
                  Gap closure activities, implementation guidance, control
                  enhancement, revalidation
                </p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-item-marker"></div>
              <div className="timeline-item-content">
                <div className="timeline-item-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewbox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <span className="timeline-item-phase">Week 13-14</span>
                <h3 className="timeline-item-title">Final Attestation</h3>
                <p className="timeline-item-description">
                  SAQ/ROC preparation, final evidence review, QSA coordination,
                  compliance certification
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" className="cta-section">
        <div className="pci-dss-compliance-cta-split">
          <div className="pci-dss-compliance-cta-content">
            <div className="cta-icon">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                viewbox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <h2 className="pci-dss-compliance-cta-title">
              Ready to Achieve PCI-DSS Compliance?
            </h2>
            <p className="pci-dss-compliance-cta-description">
              Schedule a no-obligation consultation with our PCI-DSS experts to
              discuss your compliance objectives, current posture, and readiness
              assessment needs
            </p>
            <div className="cta-features">
              <div className="pci-dss-compliance-cta-feature">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Comprehensive gap analysis</span>
              </div>
              <div className="pci-dss-compliance-cta-feature">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Evidence collection support</span>
              </div>
              <div className="pci-dss-compliance-cta-feature">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Attestation readiness guidance</span>
              </div>
            </div>
            <div className="cta-actions">
              <a href="/contact-us">
                <div className="pcidss-compliance-thq-btn-elm3 btn-primary btn-xl btn">
                  <span>Schedule Consultation</span>
                </div>
              </a>
            </div>
          </div>
          <div className="cta-visual">
            <img
              alt="Security professional working on compliance assessment"
              src="https://images.pexels.com/photos/1181317/pexels-photo-1181317.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            />
            <div className="cta-visual-overlay">
              <div className="pci-dss-compliance-cta-stat">
                <span className="cta-stat-number">98%</span>
                <span className="pci-dss-compliance-cta-stat-label">
                  Success Rate
                </span>
              </div>
              <div className="pci-dss-compliance-cta-stat">
                <span className="cta-stat-number">20+</span>
                <span className="pci-dss-compliance-cta-stat-label">
                  Assessments
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="pcidss-compliance-container2">
        <div className="pcidss-compliance-container3">
          <Script
            html={`<script defer data-name="testimonials-scroll">
(function(){
  const testimonialsRail = document.querySelector(".testimonials-rail")
  const timelineTrack = document.querySelector(".timeline-track")

  if (testimonialsRail) {
    testimonialsRail.scrollLeft = 0
  }

  if (timelineTrack) {
    timelineTrack.parentElement.scrollLeft = 0
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default PCIDSSCompliance
